import dayjs from 'dayjs';
import Vue from 'vue';
import { t } from '@/i18n/helpers';

/**
 * Formats a phone number.
 * Example: 123-456-7890 => (123) 456-7890
 *
 * @param {String} phone
 * @return {String}
 */
Vue.filter(
    'phone',
    (value) => {
        if (typeof value !== 'string') {
            return value;
        }

        return value.replace(/[^0-9]/g, '')
            .replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 $2 $3 $4 $5');
    },
);

/**
 * Дата со временем
 * Example: 2020-01-23T10:46:43Z => 23.01.20 г., 16:46
 *
 * @param {String} value
 * @return {String}
 */
Vue.filter('formatDateFull', value => (value ? dayjs(value).format(t('common.dateTimeFull')) : value));
